import { render, staticRenderFns } from "./TraitePhoto.vue?vue&type=template&id=c59d7492&scoped=true&"
import script from "./TraitePhoto.vue?vue&type=script&lang=js&"
export * from "./TraitePhoto.vue?vue&type=script&lang=js&"
import style0 from "./TraitePhoto.vue?vue&type=style&index=0&id=c59d7492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59d7492",
  null
  
)

export default component.exports